export { Thumbnail } from "./thumbnail.vue";
